/**
 * Custom React Hook to determine if the platform is macOS.
 *
 * @returns {Object} An object containing a boolean `isMac` indicating if the platform is macOS.
 */
export default function usePlatformInfo() {
  if (typeof navigator === "undefined") return { isMac: false };

  const isMac = navigator.userAgentData
    ? navigator.userAgentData.platform === "macOS"
    : navigator.userAgent.toUpperCase().includes("MAC");

  return { isMac };
}
